module.exports = __webpack_public_path__ + "static/media/allergen_celery.248ebf11.png";